import { connect } from 'react-redux';
import {
  isForecastView,
  canEditForecast,
  isKnockoutMatchEditable,
  selectTeamGroupByCode,
} from '@selectors/matches';
import { isSnapshotView } from '@selectors/location';
import { hasBothTeams } from '@utils/match';

import BracketMatch from './BracketMatch';

export const mapStateToProps = (state, match) => {
  let editable =
    !isSnapshotView(state) &&
    isForecastView(state) &&
    canEditForecast(state) &&
    isKnockoutMatchEditable(state, match);

  return {
    teams: undefined,
    teamGroupByCode: selectTeamGroupByCode(state),
    canEditTeams: false,
    canEditScore: editable && hasBothTeams(match),
    hasBothTeams: hasBothTeams(match)
  };
};

export const mapDispatchToProps = (dispatch, { mid }) => ({
  onChange: payload =>
    dispatch({
      type: 'FORECAST_MATCHES_MATCH_SET',
      meta: { mid },
      payload
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(BracketMatch);
